import React from 'react';

/** Bascule « Voir en tant que client » — réservée à l'interne, masque tout l'interne
 *  quand elle est active (preview fidèle de l'expérience client). */
const ViewAsClientToggle: React.FC<{ on: boolean; onChange: (v: boolean) => void; className?: string }> = ({ on, onChange, className = '' }) => (
  <button
    onClick={() => onChange(!on)}
    title={on ? 'Vous voyez le portail comme un client. Cliquez pour revenir en vue interne.' : 'Prévisualiser le portail exactement comme le voit le client.'}
    className={`inline-flex items-center gap-1.5 text-[11.5px] font-semibold px-2.5 py-1.5 rounded-md border transition-colors ${
      on ? 'bg-hook-rose text-white border-hook-rose' : 'border-line-2 text-dim hover:border-ink'} ${className}`}>
    👁 {on ? 'Vue client active' : 'Voir en tant que client'}
  </button>
);

export default ViewAsClientToggle;
